const MIN_ROWS = 1;
const MAX_ROWS = 10;

export const AutoExpandTextArea = (function (){
    $(document)
    .on('focus.js-auto-expand', 'textarea.js-auto-expand', function(){
        var savedValue = this.value;
        this.value = '';
        this.baseScrollHeight = this.scrollHeight;
        this.value = savedValue;
    })
    .on('input.js-auto-expand', 'textarea.js-auto-expand', function(){
        console.log(this.scrollHeight, this.baseScrollHeight);
        this.rows = MIN_ROWS;
        const rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 16);
        console.log('calced rows', rows);
        if (rows >= MAX_ROWS){
            this.rows = MAX_ROWS;
        }else if (!rows) {
            this.rows = 1;
        }else {
            this.rows = rows;
        }
        console.log('rows', this.rows);
    });
})();



// WEBPACK FOOTER //
// ./app/scripts/helpers/expandTextArea.js